import { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';
import { IUser, IFormAdminUser } from 'src/interfaces/User';
import UserEditorForm from '../forms/UserEditorForm';

interface Props extends Omit<DialogProps, 'title'> {
  handleClose: () => void;
  handleSave: (user: IFormAdminUser) => void;
  user?: IUser;
}

const UserEditorModal = ({ id, open, handleClose, handleSave, user }: Props) => {
  const { t } = useTranslation();
  const title = user
    ? t('users.editUserModalTitle', { name: user.name })
    : t('users.addUserModalTitle');

  return (
    <EditorDialogShell
      id={id ?? 'user-editor'}
      open={open}
      onClose={handleClose}
      title={title}
      maxWidth="md"
    >
      <UserEditorForm handleSave={handleSave} handleClose={handleClose} user={user} />
    </EditorDialogShell>
  );
};

export default UserEditorModal;
